import styled from 'styled-components';
import globalStyles from 'globalStyles';
import { FiraSansBold } from '@fitinsur/components/Text';
import Colors from "constants/Colors";

export const Button = styled.button`
  padding: 0.10rem 0.20rem;
  width: auto;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  white-space: nowrap;
  margin: 0px 0px 10px 15px;

  ${FiraSansBold};

  border: 0 none;
  border-radius: 8px;
  background: transparent;

  cursor: pointer;
  color: ${Colors.GRAY[6]};
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease, border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;

  text-align: center;
  &:focus,
  &:active { outline: none; }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }`;